export default "/_next/static/images/5f7990828ba812026f5eeb20423fa960.png";